import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/Badge';
import { Icon, Flex, Text } from 'roo-ui/components';

const promoIcons = {
  'Classic Reward': 'ribbon',
  'Flyer Deal': 'flightRight',
  'Member Deal': 'star',
};

const BadgeText = styled(Text)`
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PromotionalSash = ({ promotionName, fontSize }) => {
  const iconName = promoIcons[promotionName];

  return (
    <Badge overflow="hidden">
      <Flex alignItems="center">
        {iconName && <Icon name={iconName} size={16} color="greys.charcoal" mr={1} />}
        <BadgeText fontSize={fontSize}>{promotionName}</BadgeText>
      </Flex>
    </Badge>
  );
};

PromotionalSash.propTypes = {
  promotionName: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
};

PromotionalSash.defaultProps = {
  promotionName: undefined,
  fontSize: 'xs',
};

export default PromotionalSash;
